export default __webpack_public_path__ + "static/media/Img063.76306d64.jpg";